import * as Yup from "yup";
import validationUtils from "./validationUtils.js";

const forgetPasswordSchema = Yup.object().shape({
  email: validationUtils?.validateEmail(),
});

export default forgetPasswordSchema;
